import $ from 'jquery';

export default class FeatureIcons {
    constructor() {
        $('.js-feature-icons__toggle').on('click', function() {
            $(this).hide();

            $('.js-feature-icons .c-icon-pod').show();
        });
    };
};
